export default {
  required: {
    mobile: 'New mobile number is required',
    email: 'Email is required',
    placeOfPractice: 'Place of practice is required',
    qualification: 'Qualification is required',
    iban: 'IBAN is required',
    schsRegistration: 'SCHS registration number is required',
    schsExpiry: 'SCHS expiry date is required',
    city: 'City is required',
    district: 'District is required',
    street: 'Street is required',
    buildingNumber: 'Building number is required',
    zipCode: 'Zip code is required',
    additionalNumber: 'Additional number is required',
    certificate: 'National address certificate is required',
  },
  certificate: {
    fileType: 'Accepted file types: JPG, JPEG, PNG',
    fileSize: 'Maximum file size is 15 MB',
  },
  format: {
    email: 'Please provide a valid email',
    mobile:
      'Please enter a valid mobile number starting with 05 followed by 8 digits (English digits only)',
  },
  checkbox: {
    accept: 'You must accept all terms and conditions',
  },
  maxLength: 'Must not exceed {{length}} characters',
  mustBeNumber: 'Must be a valid number',
  onlyNumericAllowed: 'Only numeric characters are allowed',
  onlyAlphanumericAllowed: 'Only alphanumeric characters are allowed',
  onlyNumericMaxLength: 'Only {{length}} numeric characters are allowed',
  onlyCharMaxLength: 'Only {{length}} characters are allowed',
  mustBePositive: 'Must be a positive number',
  mustBeNonNegative: 'Must be zero or positive',
  mustBeInteger: 'Must be a whole number',
  facilityNameLength:
    'Please enter at least 3 and at most 100 characters for the facility name',
  schsRegistrationNumberLength:
    'Please enter at most {{length}} characters for the SCHS registration number',
} as const
